import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Button } from "@material-ui/core";
import AnnouncementBody from "./AnnouncementBody";
import dashboardStyles from "../dealerDashBoard/DashboardStyles.module.scss";
import styles from "./Announcement.module.scss";
import AnnouncementClient from "../../../shared/clients/AnnouncementClient";
import AnnouncementDialogNew from "./AnnouncementDialogNew";
import HasPermissionTo from "../../../common/HasPermissionTo";

class Announcement extends Component {
  constructor(props) {
    super(props);
    this.MAX_CHARACTERS = 1500;
    this.state = {
      renderApp: false,
      openNewModal: false,
      announcement: null,
    };
  }

  componentDidMount() {
    if (this.props.isNsc) this.getAnnouncements();
  }

  getAnnouncements = () => {
    AnnouncementClient.getAnnouncements(
      this.props.user,
      this.props.selectedMarket
    )
      .then((response) => {
        if (response.data[0]) this.setState({ announcement: response.data[0] });
        else this.setState({ announcement: null });
      })
      .catch(() => {
        this.setState({ announcement: null });
      })
      .finally(() => {
        this.setState({ renderApp: true });
      });
  };

  toggleNewModal = () => {
    this.setState((prevState) => ({
      openNewModal: !prevState.openNewModal,
    }));
  };

  render() {
    return (
      this.state.renderApp && (
        <>
          <div className={styles.moduleWrapper}>
            <div className={dashboardStyles.notificationHeader}>
              {this.props.t("Announcement.announcementTitle")}
            </div>
            <div className={styles.descriptionHeader}>
              {this.props.t("Announcement.descriptionTitle")}
            </div>
          </div>
          {this.state.announcement ? (
            <AnnouncementBody
              key={this.state.announcement.id}
              announcement={this.state.announcement}
              user={this.props.user}
              selectedMarket={this.props.selectedMarket}
              getAnnouncements={this.getAnnouncements}
              maxlength={this.MAX_CHARACTERS}
              t={this.props.t}
            />
          ) : (
            <div className={styles.spacer} />
          )}
          <HasPermissionTo
            perform={["nscAnnouncement:write"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={!this.state.announcement}
            render={() => (
              <div className={styles.moduleWrapper}>
                <Button
                  className={styles.announcementButton}
                  onClick={this.toggleNewModal}
                >
                  {this.props.t("Announcement.addBtn")}
                </Button>
              </div>
            )}
          />
          <AnnouncementDialogNew
            open={this.state.openNewModal}
            closeModal={this.toggleNewModal}
            getAnnouncements={this.getAnnouncements}
            user={this.props.user}
            selectedMarket={this.props.selectedMarket}
            maxlength={this.MAX_CHARACTERS}
            t={this.props.t}
          />
        </>
      )
    );
  }
}

export default withTranslation("emp")(Announcement);
